module.exports = __webpack_public_path__ + "media/images/homes/PayrollSimplified-d75930f374dd717c90b9b49ea3698bf8.png";